import "./about-me-card.css";

export default function AboutMeCard({
  name,
  title,
  photo,
  blurb,
  index,
}: {
  name: string;
  title: string;
  photo: string;
  blurb: string;
  index: number;
}) {
  return (
    <div className="-light-theme">
      <div className="ae-about-me-card-content">
        <div className="ae-about-me-card-container">
          <img className="ae-about-us-card-profile-picture" alt="" src={photo} />
        </div>
        <div className="ae-about-me-text-content-wrapper">
          <h2 className="ae-about-me-card-name -light">{name}</h2>
          <h3 className="ae-about-me-card-titles">{title}</h3>
          <p className="ae-about-me-card-blurb">{blurb}</p>
        </div>
      </div>
    </div>
  );
}
